import buyer from './buyer';
import supplier from './supplier';
import cataloger from './cataloger';

export default {
  routes: {
    ...buyer,
    ...supplier,
    ...cataloger,
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/routes/index.js